import React, { JSX } from 'react';
import { LeaveDeviceNoteForm } from '../../shared/LeaveDeviceNoteForm';
import type { DeviceNoteType } from '../../shared/types/DeviceNoteTypes';

type EventOption = { eventId: string; name?: string };

type LeaveDeviceNoteOperationProps = {
  selectedIds: string[];
  noteType: DeviceNoteType;
  noteEventId: string;
  noteBody: string;
  submitting: boolean;
  events: EventOption[];
  eventsLoading: boolean;
  onNoteTypeChange: (value: DeviceNoteType) => void;
  onNoteEventIdChange: (value: string) => void;
  onNoteBodyChange: (value: string) => void;
};

export default function LeaveDeviceNoteOperation(props: LeaveDeviceNoteOperationProps): JSX.Element {
  const {
    selectedIds,
    noteType,
    noteEventId,
    noteBody,
    submitting,
    events,
    eventsLoading,
    onNoteTypeChange,
    onNoteEventIdChange,
    onNoteBodyChange,
  } = props;

  return (
    <LeaveDeviceNoteForm
      deviceIds={selectedIds}
      noteType={noteType}
      onNoteTypeChange={onNoteTypeChange}
      message={noteBody}
      onMessageChange={onNoteBodyChange}
      disabled={submitting}
      visualVariant="configure"
      title="Leave note"
      eventAssociation={(
        <>
          <label className="block text-[11px] text-gray-700 dark:text-slate-300 mb-1">Event (optional)</label>
          <select
            className="w-full rounded-md border border-gray-300 dark:border-slate-600 px-2 py-1 text-[11px] bg-white dark:bg-slate-900 disabled:opacity-60"
            value={noteEventId}
            onChange={(e) => onNoteEventIdChange(e.target.value)}
            disabled={submitting || eventsLoading}
          >
            <option value="">No event</option>
            {events.map((ev) => (
              <option key={ev.eventId} value={ev.eventId}>
                {ev.name ? `${ev.name} (${ev.eventId})` : ev.eventId}
              </option>
            ))}
          </select>
          {eventsLoading ? <div className="mt-1 text-[11px] text-gray-500 dark:text-slate-400">Loading events...</div> : null}
        </>
      )}
      footer="external"
    />
  );
}
